import { useEffect, useState } from "react";
import { UserInfo } from "../types";
import { getUserInfo } from "../api";

const useProfile = () => {
  const [profile, setProfile] = useState<UserInfo | null>(null);

  useEffect(() => {
    getUserInfo()
      .then((res) => {
        setProfile(res);
      });
  }, []);

  return profile;
}

export default useProfile;
